// Étape 4. Configuration SEO centralisée (FR / EN / PT)
// Chaque route possède un title unique, meta description unique, et Schema.org contextuel.
// Le composant <Seo> injecte ces balises dynamiquement au changement de route.

export const SITE_URL = "https://nanda-sa.com";
export const SITE_NAME = {
 fr: "NANDA SÁ",
 en: "NANDA SÁ",
 pt: "NANDA SÁ",
};
export const DEFAULT_OG_IMAGE = "https://nanda-sa.com/photos/nanda-cosmetiques/ing-baobab-hero.jpg";

// Mapping des locales vers les codes normalisés
export const LOCALE_MAP = {
 fr: { og: "fr_FR", html: "fr", htmlAlt: "fr-FR" },
 en: { og: "en_GB", html: "en", htmlAlt: "en-GB" },
 pt: { og: "pt_PT", html: "pt", htmlAlt: "pt-PT" },
};

// Configuration SEO, l'ordre des langues : [fr, en, pt]
export const SEO_ROUTES = {
 "/": {
 title: [
 "NANDA SÁ. Réfrigération, énergie solaire, conseil et marques d'Afrique de l'Ouest",
 "NANDA SÁ. Refrigeration, solar energy, consulting and West African brands",
 "NANDA SÁ. Refrigeração, energia solar, consultoria e marcas da África Ocidental",
 ],
 description: [
 "Entreprise industrielle et multisecteur ouest-africaine. Réfrigération, climatisation, énergie solaire, conseil, matières premières naturelles, filière cajou, cosmétiques naturels NANDA SÁ, épicerie NANDA SÁ, éducation. Guinée-Bissau.",
 "West African industrial and multisector company. Refrigeration, air conditioning, solar energy, consulting, natural raw materials, cashew value chain, NANDA SÁ natural cosmetics, NANDA SÁ fine foods, education. Guinea-Bissau.",
 "Empresa industrial e multisectorial oeste-africana. Refrigeração, climatização, energia solar, consultoria, matérias-primas naturais, fileira do caju, cosméticos naturais NANDA SÁ, mercearia NANDA SÁ, educação. Guiné-Bissau.",
 ],
 schema: "home",
 },
 "/maison": {
 title: [
 "La Maison NANDA SÁ. Vision, mission et manifeste",
 "The NANDA SÁ House. Vision, mission and manifesto",
 "A Casa NANDA SÁ. Visão, missão e manifesto",
 ],
 description: [
 "Découvrez l'histoire, la vision, la mission et les valeurs du NANDA SÁ. Bâtir aujourd'hui les solutions durables de demain, entre la Guinée-Bissau.",
 "Discover the story, vision, mission and values of NANDA SÁ. Building today the sustainable solutions of tomorrow, between Guinea-Bissau.",
 "Descubra a história, a visão, a missão e os valores do NANDA SÁ. Construir hoje as soluções sustentáveis de amanhã, entre a Guiné-Bissau.",
 ],
 schema: "aboutPage",
 },
 "/marques": {
 title: [
 "Les Maisons NANDA SÁ. ENERGIA PRO · NANDA SÁ · Académie",
 "The NANDA SÁ Houses. ENERGIA PRO · NANDA SÁ · Académie",
 "As Casas NANDA SÁ. ENERGIA PRO · NANDA SÁ · Académie",
 ],
 description: [
 "Les Maisons du NANDA SÁ, chacune avec son propre univers : énergie solaire et équipements professionnels, épicerie fine, éducation et orientation.",
 "The Houses of NANDA SÁ, each with its own universe: solar energy and professional equipment, fine grocery, education and guidance.",
 "As Casas do NANDA SÁ, cada uma com o seu próprio universo: energia solar e equipamentos profissionais, mercearia fina, educação e orientação.",
 ],
 schema: "brandsIndex",
 },
 "/cosmetiques": {
 title: [
 "Cosmétiques Naturels par NANDA SÁ. Karité, baobab, moringa, hibiscus",
 "Natural Cosmetics by NANDA SÁ. Shea, baobab, moringa, hibiscus",
 "Cosméticos Naturais por NANDA SÁ. Karité, baobá, moringa, hibisco",
 ],
 description: [
 "Cosmétiques naturels premium par NANDA SÁ. Soins visage, corps, cheveux, huiles végétales et beurres inspirés de la richesse botanique d'Afrique de l'Ouest : karité, baobab, moringa, hibiscus, touloucouna. Formulations courtes, transformation locale en Guinée-Bissau.",
 "Premium natural cosmetics by NANDA SÁ. Face, body, hair care, plant oils and butters inspired by West Africa's botanical wealth: shea, baobab, moringa, hibiscus, touloucouna. Short formulations, locally crafted in Guinea-Bissau.",
 "Cosméticos naturais premium por NANDA SÁ. Cuidados para rosto, corpo, cabelo, óleos vegetais e manteigas inspirados na riqueza botânica da África Ocidental: karité, baobá, moringa, hibisco, toulucuna. Formulações curtas, transformação local na Guiné-Bissau.",
 ],
 schema: "service",
 },
 "/refrigeration-climatisation": {
 title: [
 "Réfrigération & climatisation industrielle en Guinée-Bissau | NANDA SÁ ENERGIA PRO",
 "Industrial refrigeration & air conditioning in Guinea-Bissau | NANDA SÁ ENERGIA PRO",
 "Refrigeração e climatização industrial na Guiné-Bissau | NANDA SÁ ENERGIA PRO",
 ],
 description: [
 "Étude, fourniture, installation et maintenance de chambres froides, climatisation split, VRV, chaîne du froid industrielle et SAV. Guinée-Bissau, Afrique de l'Ouest.",
 "Design, supply, installation and maintenance of cold rooms, split AC, VRV, industrial cold chain and after-sales service. Guinea-Bissau, West Africa.",
 "Estudo, fornecimento, instalação e manutenção de câmaras frias, climatização split, VRV, cadeia de frio industrial e SAV. Guiné-Bissau, África Ocidental.",
 ],
 schema: "service",
 },
 "/energies-renouvelables": {
 title: [
 "Énergies renouvelables. Solaire, stockage et efficacité en Guinée-Bissau | NANDA SÁ",
 "Renewable energy. Solar, storage and efficiency in Guinea-Bissau | NANDA SÁ",
 "Energias renováveis. Solar, armazenamento e eficiência na Guiné-Bissau | NANDA SÁ",
 ],
 description: [
 "Solutions solaires résidentielles, tertiaires, industrielles et agricoles. Stockage lithium, backup, pompage, éclairage public. Étude, installation et maintenance en Guinée-Bissau.",
 "Residential, commercial, industrial and agricultural solar solutions. Lithium storage, backup, pumping, street lighting. Design, installation and maintenance in Guinea-Bissau.",
 "Soluções solares residenciais, terciárias, industriais e agrícolas. Armazenamento de lítio, backup, bombagem, iluminação pública. Estudo, instalação e manutenção na Guiné-Bissau.",
 ],
 schema: "service",
 },
 "/matieres-premieres-naturelles": {
 title: [
 "Matières premières naturelles d'Afrique de l'Ouest | NANDA SÁ",
 "West African natural raw materials | NANDA SÁ",
 "Matérias-primas naturais da África Ocidental | NANDA SÁ",
 ],
 description: [
 "Sourcing, contrôle qualité, valorisation et mise en relation autour des matières agricoles, alimentaires et botaniques d'Afrique de l'Ouest : anacarde, karité, baobab, moringa, hibiscus, miel, sel, fonio.",
 "Sourcing, quality control, valorisation and matching around West African agricultural, food and botanical raw materials: cashew, shea, baobab, moringa, hibiscus, honey, salt, fonio.",
 "Sourcing, controlo de qualidade, valorização e mise en relation em matérias agrícolas, alimentares e botânicas da África Ocidental: caju, karité, baobá, moringa, hibisco, mel, sal, fonio.",
 ],
 schema: "service",
 },
 "/filiere-cajou": {
 title: [
 "Filière cajou en Guinée-Bissau | NANDA SÁ",
 "Cashew value chain in Guinea-Bissau | NANDA SÁ",
 "Fileira do caju na Guiné-Bissau | NANDA SÁ",
 ],
 description: [
 "Accompagnement de la filière cajou : sourcing, contrôle qualité, transformation locale, valorisation, conditionnement et développement de débouchés à l'export. Producteurs, coopératives, transformateurs et acheteurs internationaux.",
 "Support for the cashew value chain: sourcing, quality control, local processing, valorisation, packaging and development of export outlets. Producers, cooperatives, processors and international buyers.",
 "Acompanhamento da fileira do caju: sourcing, controlo de qualidade, transformação local, valorização, embalagem e desenvolvimento de saídas para exportação. Produtores, cooperativas, transformadores e compradores internacionais.",
 ],
 schema: "service",
 },
 "/produits-consommables": {
 title: [
 "Produits et consommables professionnels pour le froid, la clim et le génie climatique | NANDA SÁ",
 "Professional refrigeration, HVAC & industrial supplies and consumables | NANDA SÁ",
 "Produtos e consumíveis profissionais para refrigeração, climatização e HVAC | NANDA SÁ",
 ],
 description: [
 "NANDA SÁ approvisionne les professionnels du froid et de la climatisation : consommables frigorifiques, matériel de réfrigération, fournitures climatisation, outillage professionnel, électrodes de soudure, meules de découpe, produits de maintenance climatisation. Liste indicative, large gamme sur demande.",
 "NANDA SÁ supplies refrigeration and HVAC professionals: refrigeration supplies, HVAC supplies, industrial refrigeration equipment, professional tooling, welding electrodes, cutting discs, HVAC maintenance products. Indicative list, wide range on request.",
 "A NANDA SÁ fornece profissionais da refrigeração e climatização: consumíveis de refrigeração, material HVAC, ferramentas profissionais, eléctrodos de soldadura, discos de corte, produtos de manutenção de climatização. Lista indicativa, gama alargada sob pedido.",
 ],
 schema: "service",
 },
 "/engagement-odd": {
 title: [
 "Notre engagement pour les Objectifs de Développement Durable (ODD) | NANDA SÁ",
 "Our commitment to the UN Sustainable Development Goals (SDGs) | NANDA SÁ",
 "O nosso compromisso com os Objectivos de Desenvolvimento Sustentável (ODS) | NANDA SÁ",
 ],
 description: [
 "NANDA SÁ contribue directement à huit Objectifs de Développement Durable des Nations Unies : Éducation de qualité (ODD 4), Énergie propre (ODD 7), Travail décent (ODD 8), Industrie & innovation (ODD 9), Villes durables (ODD 11), Consommation responsable (ODD 12), Climat (ODD 13), Partenariats (ODD 17). Développement économique responsable en Afrique de l'Ouest.",
 "NANDA SÁ directly contributes to eight UN Sustainable Development Goals: Quality Education (SDG 4), Affordable & Clean Energy (SDG 7), Decent Work (SDG 8), Industry & Innovation (SDG 9), Sustainable Cities (SDG 11), Responsible Consumption (SDG 12), Climate Action (SDG 13), Partnerships (SDG 17). Responsible economic development in West Africa.",
 "A NANDA SÁ contribui directamente para oito Objectivos de Desenvolvimento Sustentável da ONU: Educação de Qualidade (ODS 4), Energia Limpa (ODS 7), Trabalho Digno (ODS 8), Indústria e Inovação (ODS 9), Cidades Sustentáveis (ODS 11), Consumo Responsável (ODS 12), Acção Climática (ODS 13), Parcerias (ODS 17). Desenvolvimento económico responsável na África Ocidental.",
 ],
 schema: "aboutPage",
 },
 "/conseil-implantation": {
 title: [
 "Conseil & implantation en Guinée-Bissau. Étude, terrains, partenaires | NANDA SÁ",
 "Consulting & establishment in Guinea-Bissau. Study, land, partners | NANDA SÁ",
 "Consultoria e implantação na Guiné-Bissau. Estudo, terrenos, parceiros | NANDA SÁ",
 ],
 description: [
 "Étude de marché, recherche de terrains, accompagnement administratif, mise en relation avec partenaires locaux, développement commercial, gestion de projet, recrutement et logistique en Guinée-Bissau et en Afrique de l'Ouest.",
 "Market study, land search, administrative support, matching with local partners, business development, project management, recruitment and logistics in Guinea-Bissau and West Africa.",
 "Estudo de mercado, procura de terrenos, apoio administrativo, mise en relation com parceiros locais, desenvolvimento comercial, gestão de projecto, recrutamento e logística na Guiné-Bissau e na África Ocidental.",
 ],
 schema: "service",
 },
 "/secteurs": {
 title: [
 "Nos secteurs d'activité. Énergie, gastronomie, cosmétiques, formation",
 "Our sectors. Energy, gastronomy, cosmetics, training",
 "Os nossos sectores. Energia, gastronomia, cosméticos, formação",
 ],
 description: [
 "Huit secteurs stratégiques : énergies renouvelables, épicerie fine, transformation alimentaire, cosmétiques naturels, éducation et art de vivre africain.",
 "Eight strategic sectors: renewable energy, fine grocery, food processing, natural cosmetics, education and African lifestyle.",
 "Oito sectores estratégicos: energias renováveis, mercearia fina, transformação alimentar, cosméticos naturais, educação e arte de viver africana.",
 ],
 schema: "sectors",
 },
 "/tresors": {
 title: [
 "Les Trésors d'Afrique de l'Ouest. Baobab, karité, hibiscus, moringa",
 "The Treasures of West Africa. Baobab, shea, hibiscus, moringa",
 "Os Tesouros da África Ocidental. Baobá, karité, hibisco, moringa",
 ],
 description: [
 "Dix ingrédients d'exception d'Afrique de l'Ouest : baobab, karité, moringa, hibiscus, miel, cacao, neem, touloucouna, thé de Gambie, maad. Histoire, récolte et bienfaits.",
 "Ten exceptional West African ingredients: baobab, shea, moringa, hibiscus, honey, cocoa, neem, touloucouna, Gambia tea, maad. Story, harvest and benefits.",
 "Dez ingredientes de excepção da África Ocidental: baobá, karité, moringa, hibisco, mel, cacau, neem, toulucuna, chá da Gâmbia, maad. História, colheita e benefícios.",
 ],
 schema: "tresors",
 },
 "/carnet": {
 title: [
 "Le Carnet NANDA SÁ. Articles, rencontres et récits d'Afrique de l'Ouest",
 "The NANDA SÁ Journal. Articles, encounters and stories from West Africa",
 "O Caderno NANDA SÁ. Artigos, encontros e relatos da África Ocidental",
 ],
 description: [
 "Le journal éditorial de NANDA SÁ : rencontres de producteurs, savoir-faire, récits de terroir et actualités de la Maison.",
 "The editorial journal of NANDA SÁ: producer encounters, know-how, terroir stories and House news.",
 "O jornal editorial da NANDA SÁ: encontros de produtores, saberes, relatos de terroir e actualidades da Casa.",
 ],
 schema: "blog",
 },
 "/actualites": {
 title: [
 "Actualités. Presse et communication du NANDA SÁ",
 "News. Press and communications from NANDA SÁ",
 "Actualidades. Imprensa e comunicação do NANDA SÁ",
 ],
 description: [
 "Retrouvez les actualités, communiqués et prises de parole du NANDA SÁ en Afrique de l'Ouest et à l'international.",
 "The latest news, press releases and thought leadership from NANDA SÁ in West Africa and internationally.",
 "Todas as actualidades, comunicados e tomadas de posição do NANDA SÁ na África Ocidental e a nível internacional.",
 ],
 schema: "news",
 },
 "/impact": {
 title: [
 "Notre impact. Économique, social et environnemental",
 "Our impact. Economic, social and environmental",
 "O nosso impacto. Económico, social e ambiental",
 ],
 description: [
 "L'empreinte réelle du NANDA SÁ : emplois créés, producteurs partenaires, énergie propre déployée et engagement pour les générations futures.",
 "The real footprint of NANDA SÁ: jobs created, partner producers, clean energy deployed and commitment to future generations.",
 "A pegada real do NANDA SÁ: empregos criados, produtores parceiros, energia limpa implementada e compromisso com as gerações futuras.",
 ],
 schema: "impact",
 },
 "/partenaires": {
 title: [
 "Nos partenaires. Distributeurs, hôtels, institutions, investisseurs",
 "Our partners. Distributors, hotels, institutions, investors",
 "Os nossos parceiros. Distribuidores, hotéis, instituições, investidores",
 ],
 description: [
 "Distribution, retail, hôtellerie, institutions, presse et investisseurs : découvrez les opportunités de partenariat avec le NANDA SÁ.",
 "Distribution, retail, hospitality, institutions, press and investors: discover partnership opportunities with NANDA SÁ.",
 "Distribuição, retalho, hotelaria, instituições, imprensa e investidores: descubra as oportunidades de parceria com o NANDA SÁ.",
 ],
 schema: "partners",
 },
 "/rejoindre": {
 title: [
 "Nous rejoindre. Carrières au NANDA SÁ",
 "Join us. Careers at NANDA SÁ",
 "Junte-se a nós. Carreiras no NANDA SÁ",
 ],
 description: [
 "Rejoignez une aventure entrepreneuriale ouest-africaine ambitieuse. Postes ouverts entre le la Guinée-Bissau et l'international.",
 "Join an ambitious West African entrepreneurial adventure. Open positions between Guinea-Bissau and international.",
 "Junte-se a uma aventura empresarial oeste-africana ambiciosa. Vagas abertas entre o a Guiné-Bissau e o mercado internacional.",
 ],
 schema: "careers",
 },
 "/contact": {
 title: [
 "Contact. Canchungo · International",
 "Contact. Canchungo · International",
 "Contacto. Canchungo · Internacional",
 ],
 description: [
 "Contactez le NANDA SÁ. Implantations à Canchungo (Guinée-Bissau). Distribution, presse, partenariats, investisseurs.",
 "Contact NANDA SÁ. Locations in Canchungo (Guinea-Bissau) and (Guinea-Bissau). Distribution, press, partnerships, investors.",
 "Contacte o NANDA SÁ. Implantações em Canchungo (Guiné-Bissau) e (Guinea-Bissau). Distribuição, imprensa, parcerias, investidores.",
 ],
 schema: "contact",
 },
 "/mediatheque": {
 title: [
 "Médiathèque. Images, films, catalogues et communiqués | NANDA SÁ",
 "Media Library. Images, films, catalogues and press releases | NANDA SÁ",
 "Mediateca. Imagens, filmes, catálogos e comunicados | NANDA SÁ",
 ],
 description: [
 "La médiathèque officielle du NANDA SÁ. Photothèque, vidéos, catalogues professionnels, communiqués de presse, kit presse, accès sur demande.",
 "The official media library of NANDA SÁ. Photo library, videos, professional catalogues, press releases, press kit, access on request.",
 "A mediateca oficial do NANDA SÁ. Fototeca, vídeos, catálogos profissionais, comunicados de imprensa, kit de imprensa, acesso a pedido.",
 ],
 schema: "media",
 },
 "/identite": {
 title: [
 "Identité visuelle NANDA SÁ. Charte graphique et style guide",
 "NANDA SÁ Visual Identity. Brand guidelines and style guide",
 "Identidade visual NANDA SÁ. Manual de marca e guia de estilo",
 ],
 description: [
 "Le système d'identité visuelle du NANDA SÁ : monogrammes, palette, typographie, principes graphiques. Style guide téléchargeable.",
 "The visual identity system of NANDA SÁ: monograms, palette, typography, graphic principles. Downloadable style guide.",
 "O sistema de identidade visual do NANDA SÁ: monogramas, paleta, tipografia, princípios gráficos. Manual descarregável.",
 ],
 schema: "identity",
 },
 "/devis": {
 title: [
 "Demande de devis & de projet. NANDA SÁ",
 "Quote & project request. NANDA SÁ",
 "Pedido de orçamento e projecto. NANDA SÁ",
 ],
 description: [
 "Demandez un devis pour l'ensemble des activités NANDA SÁ : énergie solaire, matériel électrique, EPI, cosmétiques naturels, épicerie NANDA SÁ, formation Académie. Réponse sous 48 h.",
 "Request a quote for all NANDA SÁ activities: solar energy, electrical equipment, PPE, natural cosmetics, NANDA SÁ fine foods, Académie training. Reply within 48 hours.",
 "Peça um orçamento para todas as actividades NANDA SÁ: energia solar, material eléctrico, EPI, cosméticos naturais, mercearia NANDA SÁ, formação Académie. Resposta em 48 h.",
 ],
 schema: "generic",
 },
 "/telecharger": {
 title: [
 "Télécharger le site & le catalogue NANDA SÁ",
 "Download the NANDA SÁ site & catalogue",
 "Descarregar o site e catálogo NANDA SÁ",
 ],
 description: [
 "Portail de téléchargement NANDA SÁ : archive ZIP du site prête à déployer sur GoDaddy, catalogue officiel PDF 2026-2027 (54 pages, trilingue) et style guide.",
 "NANDA SÁ download portal: ready-to-deploy site ZIP archive for GoDaddy, official 2026-2027 PDF catalogue (54 pages, trilingual) and style guide.",
 "Portal de descarga NANDA SÁ: arquivo ZIP do site pronto para deploy no GoDaddy, catálogo oficial PDF 2026-2027 (54 páginas, trilingue) e manual de estilo.",
 ],
 schema: "generic",
 },
 "/secteurs/cajou": {
 title: [
 "Investir dans la filière cajou en Guinée-Bissau | NANDA SÁ",
 "Investing in the cashew value chain in Guinea-Bissau | NANDA SÁ",
 "Investir na fileira do caju na Guiné-Bissau | NANDA SÁ",
 ],
 description: [
 "Panorama complet de la filière cajou en Guinée-Bissau : chiffres clés, chaîne de valeur, segments d'investissement, cadre institutionnel, opportunités pour la diaspora.",
 "A complete panorama of the cashew value chain in Guinea-Bissau: key figures, value chain, investment segments, institutional framework, opportunities for the diaspora.",
 "Panorama completo da fileira do caju na Guiné-Bissau: dados-chave, cadeia de valor, segmentos de investimento, enquadramento institucional, oportunidades para a diáspora.",
 ],
 schema: "article",
 },
 "/opportunites": {
 title: [
 "Les opportunités de la vie. Canchungo, Cacheu et l'avenir de la Guinée-Bissau | NANDA SÁ",
 "The opportunities of a lifetime. Canchungo, Cacheu and the future of Guinea-Bissau | NANDA SÁ",
 "As oportunidades da vida. Canchungo, Cacheu e o futuro da Guiné-Bissau | NANDA SÁ",
 ],
 description: [
 "Pourquoi Canchungo peut devenir l'un des territoires les plus prometteurs d'Afrique de l'Ouest : noix de cajou, agriculture, énergies renouvelables, proximité avec la Guinée-Bissau et jeunesse. Un panorama pour investisseurs, entreprises et institutions par NANDA SÁ.",
 "Why Canchungo can become one of West Africa's most promising territories: cashew nuts, agriculture, renewable energy, proximity to Guinea-Bissau and youth. A panorama for investors, companies and institutions by NANDA SÁ.",
 "Porque Canchungo pode tornar-se num dos territórios mais promissores da África Ocidental: castanha de caju, agricultura, energias renováveis, proximidade com o Guinea-Bissau e juventude. Um panorama para investidores, empresas e instituições, por NANDA SÁ.",
 ],
 schema: "article",
 },
 "/devis": {
 title: [
 "Demande de devis B2B, réfrigération, solaire, cajou, consommables | NANDA SÁ",
 "B2B quote request, refrigeration, solar, cashew, supplies | NANDA SÁ",
 "Pedido de orçamento B2B, refrigeração, solar, caju, consumíveis | NANDA SÁ",
 ],
 description: [
 "Formulaire sécurisé de demande de devis NANDA SÁ. Réfrigération industrielle, chambres froides, climatisation, énergies renouvelables, matières premières, filière cajou, cosmétiques naturels, consommables et conseil. Trilingue FR/EN/PT. Pièces jointes chiffrées, non publiques.",
 "Secure quote request form from NANDA SÁ. Industrial refrigeration, cold rooms, HVAC, renewable energy, raw materials, cashew value chain, natural cosmetics, consumables and consulting. Trilingual FR/EN/PT. Encrypted, non-public attachments.",
 "Formulário seguro de pedido de orçamento NANDA SÁ. Refrigeração industrial, câmaras frias, climatização, energias renováveis, matérias-primas, fileira do caju, cosméticos naturais, consumíveis e consultoria. Trilingue FR/EN/PT. Anexos cifrados, não públicos.",
 ],
 schema: "service",
 },
 "/legal/mentions": {
 title: [
 "Mentions légales | NANDA SÁ, entreprise multisectorielle en Afrique de l'Ouest",
 "Legal notice | NANDA SÁ, multisector company in West Africa",
 "Menções legais | NANDA SÁ, empresa multisectorial na África Ocidental",
 ],
 description: [
 "Mentions légales du site www.nanda-sa.com : éditeur (NANDA SÁ, entreprise multisectorielle en Guinée-Bissau), directrice de la publication Kadidia DIOP, hébergement, propriété intellectuelle, photographies, limitation de responsabilité, protection des données personnelles, cookies, droit applicable et contact hello@nanda-sa.com.",
 "Legal notice for www.nanda-sa.com: publisher (NANDA SÁ, multisector company in Guinea-Bissau), director of publication Kadidia DIOP, hosting, intellectual property, photographs, limitation of liability, personal data protection, cookies, applicable law and contact at hello@nanda-sa.com.",
 "Menções legais do site www.nanda-sa.com: editor (NANDA SÁ, empresa multisectorial na Guiné-Bissau e no Guinea-Bissau), directora de publicação Kadidia DIOP, alojamento, propriedade intelectual, fotografias, limitação de responsabilidade, protecção dos dados pessoais, cookies, direito aplicável e contacto em hello@nanda-sa.com.",
 ],
 schema: "generic",
 },
 "/legal/confidentialite": {
 title: [
 "Politique de confidentialité. NANDA SÁ",
 "Privacy policy. NANDA SÁ",
 "Política de privacidade. NANDA SÁ",
 ],
 description: [
 "Politique de confidentialité NANDA SÁ : traitement des données personnelles, formulaires, newsletter, durée de conservation, droits des utilisateurs et coordonnées DPO.",
 "NANDA SÁ privacy policy: personal data processing, forms, newsletter, retention period, user rights and DPO contact details.",
 "Política de privacidade NANDA SÁ: tratamento de dados pessoais, formulários, newsletter, período de conservação, direitos dos utilizadores e contactos do DPO.",
 ],
 schema: "generic",
 },
 "/legal/cookies": {
 title: [
 "Politique cookies. NANDA SÁ",
 "Cookie policy. NANDA SÁ",
 "Política de cookies. NANDA SÁ",
 ],
 description: [
 "Politique de gestion des cookies sur nanda-sa.com : cookies techniques, analytiques et de préférences, consentement et paramétrage utilisateur.",
 "Cookie management policy on nanda-sa.com: technical, analytical and preference cookies, consent and user settings.",
 "Política de gestão de cookies em nanda-sa.com: cookies técnicos, analíticos e de preferências, consentimento e configurações do utilizador.",
 ],
 schema: "generic",
 },
};

// Configuration SEO par slug de marque
export const BRAND_SEO = {
 'nanda-sa': {
 title: [
 "NANDA SÁ. Épicerie fine et anacarde d'Afrique de l'Ouest | NANDA SÁ",
 "NANDA SÁ. West African fine grocery and cashew | NANDA SÁ",
 "NANDA SÁ. Mercearia fina e caju da África Ocidental | NANDA SÁ",
 ],
 description: [
 "NANDA SÁ : épicerie fine, anacarde, fruits tropicaux, miel, sel, épices, les trésors culinaires d'Afrique de l'Ouest. Filières tracées, producteurs respectés.",
 "NANDA SÁ: fine foods, cashew, tropical fruits, honey, salt, spices, the culinary treasures of West Africa. Traceable supply chains, respected producers.",
 "NANDA SÁ: mercearia fina, caju, frutos tropicais, mel, sal, especiarias, os tesouros culinários da África Ocidental. Fileiras rastreadas, produtores respeitados.",
 ],
 },
 "energia-pro": {
 title: [
 "NANDA SÁ ENERGIA PRO. Solutions froid, climatisation, énergie solaire B2B en Afrique de l'Ouest",
 "NANDA SÁ ENERGIA PRO. Refrigeration, air conditioning, solar energy B2B solutions in West Africa",
 "NANDA SÁ ENERGIA PRO. Soluções de frio, climatização e energia solar B2B na África Ocidental",
 ],
 description: [
 "Partenaire technique B2B multi-expertise en Afrique de l'Ouest : réfrigération industrielle et commerciale, chambres froides positives et négatives, climatisation professionnelle, groupes frigorifiques, énergie solaire photovoltaïque, batteries LiFePO₄, onduleurs hybrides, pompage solaire, outillage frigoriste et EPI. Étude, installation, maintenance. Guinée-Bissau.",
 "B2B multi-expertise technical partner in West Africa: industrial and commercial refrigeration, positive and negative cold rooms, professional air conditioning, refrigeration units, solar photovoltaic energy, LiFePO₄ batteries, hybrid inverters, solar pumping, refrigeration tools and PPE. Study, installation, maintenance. Guinea-Bissau, Guinée-Bissau.",
 "Parceiro técnico B2B multi-especialista na África Ocidental: refrigeração industrial e comercial, câmaras frigoríficas positivas e negativas, climatização profissional, grupos frigoríficos, energia solar fotovoltaica, baterias LiFePO₄, inversores híbridos, bombagem solar, ferramentas frigoristas e EPI. Estudo, instalação, manutenção. Guiné-Bissau.",
 ],
 },
 academie: {
 title: [
 "NANDA SÁ Académie. Éducation, orientation, numérique, lecture et découverte des métiers",
 "NANDA SÁ Académie. Education, guidance, digital, reading and career discovery",
 "NANDA SÁ Académie. Educação, orientação, digital, leitura e descoberta de profissões",
 ],
 description: [
 "NANDA SÁ Académie : initiative éducative dédiée à l'orientation scolaire et professionnelle, à la culture numérique, à la lecture, à la découverte des métiers, à l'entrepreneuriat et au leadership. Programmes co-construits avec écoles, collectivités, associations et entreprises. Guinée-Bissau.",
 "NANDA SÁ Académie: an educational initiative dedicated to school and career guidance, digital literacy, reading, career discovery, entrepreneurship and leadership. Programmes co-built with schools, local authorities, associations and businesses. Guinée-Bissau & Guinea-Bissau.",
 "NANDA SÁ Académie: iniciativa educativa dedicada à orientação escolar e profissional, à cultura digital, à leitura, à descoberta de profissões, ao empreendedorismo e à liderança. Programas co-construídos com escolas, autarquias, associações e empresas. Guiné-Bissau.",
 ],
 },
};

// Helper : retourne l'index de langue
export const localeIndex = (locale) => (locale === "en" ? 1 : locale === "pt" ? 2 : 0);
